<template>
  <div class="auth-shell auth-shell--centered">
    <div class="auth-card">
      <div class="auth-card__logo">
        <img src="@/assets/logos/sucasuc/logo.png" alt="logo" />
      </div>
      <div class="auth-card__heading">
        <h3>{{ $t("pages.login.description") }}</h3>
        <h5>{{ $t("pages.appConfiguration.appConfigurationCompanyCode") }}</h5>
      </div>

      <form @submit.prevent="getAppConfiguration" class="auth-card__panel">
        <div class="alert alert-danger" role="alert" v-if="error">
          {{ error }}
        </div>

        <code-company-field :form="form" name="codeCompany" id="codeCompany" />

        <div class="text-center">
          <vue-button
            :title="$t('pages.appConfiguration.appConfigurationCheckCode')"
            :loading="isLoading"
            class="btn btn-primary btn-block p-3 text-uppercase"
            type="submit"
          />
        </div>
      </form>

      <div class="auth-card__copyright">
        {{ copyright }}
      </div>
      <div class="auth-card__stores">
        <google-play-badge class="mr-3" />
        <apple-store-badge />
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/user";

import { mapActions, mapGetters } from "vuex";
import { VueButton, Form } from "@/components/form";
import { RequiredRule } from "@/components/form/data/rules";
import { CodeCompanyField } from "@/pages/auth/fields";
import * as Sentry from "@sentry/vue";

import { AppleStoreBadge, GooglePlayBadge } from "@/components";

export default {
  layout: "BasicLayout",
  middleware: "guest",
  components: {
    VueButton,
    CodeCompanyField,
    AppleStoreBadge,
    GooglePlayBadge,
  },
  data() {
    return {
      error: null,
      form: new Form({
        data: {
          codeCompany: null,
        },
      }),
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("app", ["appVersion", "logoPath", "copyright"]),
    fieldsRules() {
      return [
        new RequiredRule({
          name: "codeCompany",
          errorMessage: this.$t("components.fields.rules.required"),
        }),
      ];
    },
  },
  methods: {
    ...mapActions("auth", ["saveAppConfiguration"]),
    clear() {
      this.form.reset();
      this.form.clear();
    },
    async getAppConfiguration() {
      this.form.setFieldsRules(this.fieldsRules);

      if (this.form.validate()) {
        this.isLoading = true;
        this.error = "";
        const data = this.form.data();

        Sentry.setContext("codeCompanyData", {
          codeCompany: data.codeCompany,
        });

        api
          .getAppConfiguration({ code: data.codeCompany })
          .then(async (response) => {
            var appConfigurationData = response.data || {};

            this.saveAppConfiguration({
              ...appConfigurationData,
              code: appConfigurationData.code || appConfigurationData.Code || data.codeCompany,
            });
            this.clear();

            await this.$router.push({ name: "login" });
          })
          .catch((error) => {
            console.error(error);
            if (error.message.toLowerCase() === "network error") {
              this.error = this.$t("components.messages.network_error");
            } else if (error.response) {
              if (error.response.status === 404) {
                this.error = this.$t("pages.appConfiguration.appConfigurationCodeNotExist");
                this.clear();
              } else {
                //unsigned error
                Sentry.captureException(error);
                this.error = this.$t("components.messages.error");
              }
            } else {
              //unsigned error
              Sentry.captureException(error);
              this.error = this.$t("components.messages.error");
            }
          })
          .then(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>
